import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import SocialService from '../../../services/social.service';
import * as log from '../../../utils/log';
import { filterOutAction } from '../Guild/slice';
import { getNotification } from '../Notifications/slice';
export var SocialActionsName;
(function (SocialActionsName) {
    SocialActionsName["GET_FRIENDS"] = "getFriends";
    SocialActionsName["DELETE_FRIENDS"] = "deleteFriends";
    SocialActionsName["GET_FRIENDS_STATUS"] = "getFriendStatus";
    SocialActionsName["INVITE_FRIEND"] = "inviteFriends";
    SocialActionsName["REMOVE_FRIEND_REQUEST"] = "removeFriendRequest";
    SocialActionsName["APPROVE_INVITE"] = "approveInvite";
})(SocialActionsName || (SocialActionsName = {}));
export const getFriends = createAsyncThunk('/friends', async (name) => {
    try {
        return await SocialService.getFriends(name);
    }
    catch (err) {
        return err.response;
    }
});
export const getFriendStatus = createAsyncThunk('/friends/address/:address', async (name) => {
    try {
        return await SocialService.getFriendStatus(name);
    }
    catch (err) {
        return err.response;
    }
});
export const deleteFriend = createAsyncThunk('friends/delete/:userId', async (id) => {
    try {
        return await SocialService.deleteFriend(id);
    }
    catch (err) {
        return err.response;
    }
});
export const inviteFriend = createAsyncThunk('friends/invite/:userId', async (data) => {
    try {
        await SocialService.inviteFriend(data.inviteId);
        return await SocialService.getFriendStatus(data.address);
    }
    catch (err) {
        return err.response;
    }
});
export const approveInvite = createAsyncThunk('friends/approve-invite/:userId', async (data, { dispatch }) => {
    try {
        await SocialService.approveInvite(data.inviteId);
        if (data.notificationId) {
            dispatch(getNotification(data.notificationId));
        }
        return await SocialService.getFriendStatus(data.address);
    }
    catch (err) {
        return err.response;
    }
});
export const disapproveInvite = createAsyncThunk('friends/disprove-invite/:invite', async ({ inviteId, notificationId }, { dispatch }) => {
    try {
        const result = await SocialService.disproveInvite(inviteId);
        if (notificationId) {
            dispatch(getNotification(notificationId));
        }
        return result;
    }
    catch (err) {
        return err.response;
    }
});
export const removeFriendsRequest = createAsyncThunk('friends/invite/:userId/remove', async (data) => {
    try {
        await SocialService.removeFriendsRequest(data.userId);
        return await SocialService.getFriendStatus(data.address);
    }
    catch (err) {
        return err.response;
    }
});
export const initialState = {
    friends: null,
    pending: [],
    error: null,
    friendStatus: null,
    isDataSent: [],
    showDeleteModal: false
};
export const slice = createSlice({
    name: 'social',
    initialState,
    reducers: {
        setDeleteModal: (state, action) => {
            state.showDeleteModal = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getFriends.fulfilled, (state, action) => {
            // state.pending = filterOutAction(state.pending, SocialActionsName.GET_FRIENDS);
            state.isDataSent = filterOutAction(state.isDataSent, SocialActionsName.GET_FRIENDS);
            if (action.payload.status === 200) {
                state.isDataSent.push(SocialActionsName.GET_FRIENDS);
                state.friends = action.payload.data;
                log.debug(action.payload.data);
                state.error = null;
            }
            if (action.payload.status !== 200) {
                log.error(action.payload.error);
                state.error = action.payload.error;
            }
        });
        builder.addCase(getFriends.rejected, (state) => {
            // state.pending = filterOutAction(state.pending, SocialActionsName.GET_FRIENDS);
            state.isDataSent = filterOutAction(state.isDataSent, SocialActionsName.GET_FRIENDS);
        });
        builder.addCase(getFriends.pending, (state) => {
            // state.pending.push(SocialActionsName.GET_FRIENDS);
        });
        builder.addCase(deleteFriend.fulfilled, (state, action) => {
            state.pending = filterOutAction(state.pending, SocialActionsName.DELETE_FRIENDS);
            state.isDataSent = filterOutAction(state.isDataSent, SocialActionsName.DELETE_FRIENDS);
            if (action.payload.status === 200 && state.friends) {
                state.isDataSent.push(SocialActionsName.DELETE_FRIENDS);
                state.friends = [...state.friends.filter(({ id }) => id !== action.meta.arg)];
                state.showDeleteModal = true;
            }
        });
        builder.addCase(deleteFriend.rejected, (state) => {
            state.pending = filterOutAction(state.pending, SocialActionsName.DELETE_FRIENDS);
            state.isDataSent = filterOutAction(state.isDataSent, SocialActionsName.DELETE_FRIENDS);
            state.showDeleteModal = false;
        });
        builder.addCase(deleteFriend.pending, (state) => {
            state.pending.push(SocialActionsName.DELETE_FRIENDS);
        });
        builder.addCase(getFriendStatus.fulfilled, (state, action) => {
            state.pending = filterOutAction(state.pending, SocialActionsName.GET_FRIENDS_STATUS);
            if (action.payload.status === 200) {
                state.friendStatus = action.payload.data;
                state.isDataSent.push(SocialActionsName.GET_FRIENDS_STATUS);
                state.showDeleteModal = false;
            }
            else {
                state.isDataSent = filterOutAction(state.isDataSent, SocialActionsName.GET_FRIENDS_STATUS);
                state.showDeleteModal = true;
            }
        });
        builder.addCase(getFriendStatus.rejected, (state) => {
            state.pending = filterOutAction(state.pending, SocialActionsName.GET_FRIENDS_STATUS);
            state.isDataSent = filterOutAction(state.isDataSent, SocialActionsName.GET_FRIENDS_STATUS);
        });
        builder.addCase(getFriendStatus.pending, (state) => {
            state.pending.push(SocialActionsName.GET_FRIENDS_STATUS);
        });
        builder.addCase(inviteFriend.fulfilled, (state, action) => {
            state.pending = filterOutAction(state.pending, SocialActionsName.INVITE_FRIEND);
            if (action.payload.status === 200) {
                state.isDataSent.push(SocialActionsName.INVITE_FRIEND);
                state.friendStatus = action.payload.data;
                toast.success('Request sent!');
            }
            else {
                state.isDataSent = filterOutAction(state.isDataSent, SocialActionsName.INVITE_FRIEND);
            }
        });
        builder.addCase(inviteFriend.rejected, (state) => {
            state.pending = filterOutAction(state.pending, SocialActionsName.INVITE_FRIEND);
            state.isDataSent = filterOutAction(state.isDataSent, SocialActionsName.INVITE_FRIEND);
        });
        builder.addCase(inviteFriend.pending, (state) => {
            state.pending.push(SocialActionsName.INVITE_FRIEND);
        });
        builder.addCase(removeFriendsRequest.fulfilled, (state, action) => {
            state.pending = filterOutAction(state.pending, SocialActionsName.REMOVE_FRIEND_REQUEST);
            if (action.payload.status === 200) {
                state.friendStatus = action.payload.data;
                state.isDataSent.push(SocialActionsName.REMOVE_FRIEND_REQUEST);
                toast.success('Request removed!');
            }
            else {
                state.isDataSent = filterOutAction(state.isDataSent, SocialActionsName.REMOVE_FRIEND_REQUEST);
            }
        });
        builder.addCase(removeFriendsRequest.rejected, (state) => {
            state.pending = filterOutAction(state.pending, SocialActionsName.REMOVE_FRIEND_REQUEST);
            state.isDataSent = filterOutAction(state.isDataSent, SocialActionsName.REMOVE_FRIEND_REQUEST);
        });
        builder.addCase(removeFriendsRequest.pending, (state) => {
            state.pending.push(SocialActionsName.REMOVE_FRIEND_REQUEST);
        });
        builder.addCase(approveInvite.fulfilled, (state, action) => {
            state.pending = filterOutAction(state.pending, SocialActionsName.APPROVE_INVITE);
            if (action.payload.status === 200) {
                state.friendStatus = action.payload.data;
                state.isDataSent.push(SocialActionsName.APPROVE_INVITE);
                toast.success('Invitation approved!');
            }
            else {
                state.isDataSent = filterOutAction(state.isDataSent, SocialActionsName.APPROVE_INVITE);
            }
        });
        builder.addCase(approveInvite.rejected, (state) => {
            state.pending = filterOutAction(state.pending, SocialActionsName.APPROVE_INVITE);
            state.isDataSent = filterOutAction(state.isDataSent, SocialActionsName.APPROVE_INVITE);
        });
        builder.addCase(approveInvite.pending, (state) => {
            state.pending.push(SocialActionsName.APPROVE_INVITE);
        });
    }
});
export const { setDeleteModal } = slice.actions;
export default slice.reducer;
